<!-- ═══════════════ Accept referral — link an existing resident, create a new one, or just Accept ═══════════════
     Layout: fixed header · ONE scrolling body · sticky action bar (no content bleeding behind the buttons). -->
<div class="ar-dialog">

  <header class="ar-head">
    <div class="ar-head-ic"><mat-icon>how_to_reg</mat-icon></div>
    <div class="ar-head-txt">
      <h2>Accept referral</h2>
      <p><b>{{ personName || referralName }}</b><span class="ar-dot">·</span>choose how the resident record is handled</p>
    </div>
    <button mat-icon-button class="ar-close" (click)="close()" matTooltip="Close"><mat-icon>close</mat-icon></button>
  </header>

  <mat-dialog-content class="ar-body">

    <!-- Two columns (2026-09-28): LEFT = status notes + who is this for · RIGHT = resident record + notification email.
         Balanced so the body fits without a vertical scrollbar on a normal screen. -->
    <div class="ar-cols">
    <div class="ar-col">

    <!-- Current hospital-portal response (noticeable — the user is about to change it) -->
    <div class="ar-note history" *ngIf="data?.selectedRecord?.isExternal && data?.selectedRecord?.sourceResponseName">
      <mat-icon>history</mat-icon>
      <span>Previously sent <b>{{ data.selectedRecord.sourceResponseName }}</b><ng-container *ngIf="data.selectedRecord.sourceResponseBy"> by <b>{{ data.selectedRecord.sourceResponseBy }}</b></ng-container></span>
    </div>

    <!-- Sync OFF: accepting will update Flowtrics only — say so BEFORE they confirm -->
    <div class="ar-note warn" *ngIf="data?.selectedRecord?.isExternal && data?.portalSyncOff">
      <mat-icon>sync_disabled</mat-icon>
      <span><b>Your CarePort sync is off — this Accept will update Flowtrics only.</b>
        The resident is created and emails go out as usual, but <b>the hospital will NOT be notified</b>.
        To notify them, enable Sync in <b>My Profile → External Referral Sources</b> first.</span>
    </div>

    <!-- Internal / single-facility rows: the referral's current status, so the user knows what they are changing -->
    <div class="ar-note history" *ngIf="!data?.selectedRecord?.sourceResponseName && !providerOptions.length">
      <mat-icon>history</mat-icon>
      <span>Current status <b>{{ rowState() }}</b></span>
    </div>

    <!-- ── Who is this Accept for (multi-recipient portal referrals) ── -->
    <section class="ar-section" *ngIf="providerOptions.length">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">fact_check</mat-icon>
        <h3>Who is this Accept for?</h3>
        <span class="ar-sec-sub">this referral went to {{ providerOptions.length }} facilities</span>
      </div>
      <div class="ar-pick">
        <label class="ar-pick-item" *ngFor="let f of providerOptions"
               [class.checked]="selectedProviderKeys[provKey(f)]"
               [class.disabled]="providerDisabled(f)"
               [class.already]="alreadyIn(f)"
               [matTooltip]="providerHint(f)">
          <input type="checkbox" [checked]="selectedProviderKeys[provKey(f)]"
                 [disabled]="providerDisabled(f)"
                 (change)="onProviderToggle(f, $any($event.target).checked)" />
          <span class="ar-pick-txt">
            <span class="ar-pick-row">
              <span class="ar-pick-nm">{{ f.facilityName }}</span>
              <span class="ar-pick-mine" *ngIf="f.isMine">this office</span>
              <span class="ar-pick-already" *ngIf="alreadyIn(f)">already {{ actionLabel() }}</span>
            </span>
            <!-- current state of this facility: who · when -->
            <span class="ar-pick-st">{{ stateLine(f) || 'No response yet' }}</span>
          </span>
        </label>
      </div>
      <div class="ar-pick-warn" *ngIf="!canSubmitProviders() && !allAlready()">
        <mat-icon>error_outline</mat-icon> Select at least one facility to continue.
      </div>
      <!-- Same response again: those facilities stay unselectable and the user is told why -->
      <div class="ar-note warn" style="margin-top:10px" *ngIf="alreadyList().length && !allAlready()">
        <mat-icon>info_outline</mat-icon>
        <span><b>Already {{ actionLabel() }}:</b> {{ alreadyText() }}. These cannot be selected again — the hospital already has that answer for them.</span>
      </div>
      <div class="ar-note danger" style="margin-top:10px" *ngIf="allAlready()">
        <mat-icon>block</mat-icon>
        <span>Every facility on this referral is already <b>{{ actionLabel() }}</b> — there is nothing new to send.</span>
      </div>
      <!-- Accept sent ONLY on behalf of other facilities: the hospital is told for THEM -->
      <div class="ar-note info" style="margin-top:12px" *ngIf="onBehalfOfOthersOnly()">
        <mat-icon>info_outline</mat-icon>
        <span>Accepting on behalf of <b>{{ selectedProviders()[0]?.facilityName }}</b><ng-container *ngIf="selectedProviders().length > 1"> and {{ selectedProviders().length - 1 }} more</ng-container>
          — the hospital is notified for that facility. <b>No resident is linked in this office</b>;
          <ng-container *ngIf="residentOffices().length; else noResOffice">a new resident can be created in <b>{{ residentOfficeName() }}</b> (see below), or use <b>Accept</b>.</ng-container>
          <ng-template #noResOffice>use <b>Accept</b> and create the resident later from that office's Accepted list.</ng-template></span>
      </div>
      <!-- WHICH office the new resident is created in (selected facilities' offices the user can work in) -->
      <div class="ar-office-row" *ngIf="selectedProviders().length && residentOffices().length">
        <mat-icon>business</mat-icon>
        <label for="residentOfficeMatch">Create the resident in</label>
        <select id="residentOfficeMatch" class="ar-select" [(ngModel)]="residentOfficeID">
          <option *ngFor="let o of residentOffices()" [ngValue]="o.officeID">{{ o.officeName }}<ng-container *ngIf="o.isThisOffice"> (this office)</ng-container> — {{ o.facilityName }}</option>
        </select>
      </div>
      <div class="ar-note info" style="margin-top:10px" *ngIf="residentTargetOffice() > 0">
        <mat-icon>info_outline</mat-icon>
        <span>A new resident will be created in <b>{{ residentOfficeName() }}</b> and linked to <b>{{ residentFacilityName() }}</b>. It will not appear in this office's residents.</span>
      </div>
      <div class="ar-note warn" style="margin-top:10px" *ngIf="selectedProviders().length && residentOfficesMissing().length">
        <mat-icon>warning_amber</mat-icon>
        <span>No office is available for <b>{{ residentOfficesMissing()[0]?.facilityName }}</b><ng-container *ngIf="residentOfficesMissing().length > 1"> and {{ residentOfficesMissing().length - 1 }} more</ng-container>
          (not mapped, or you have no access) — its resident can be created later from that office's Accepted list.</span>
      </div>
    </section>

    <!-- Internal / single-facility (no picker): the resident record fills the LEFT column -->
    <ng-container *ngIf="!providerOptions.length"><ng-container *ngTemplateOutlet="residentSec"></ng-container></ng-container>
    </div>
    <div class="ar-col">

    <!-- Multi-facility (picker on the left): the resident record heads the RIGHT column -->
    <ng-container *ngIf="providerOptions.length"><ng-container *ngTemplateOutlet="residentSec"></ng-container></ng-container>

    <!-- ── 1. Notification ── -->
    <section class="ar-section">
      <div class="ar-sec-head">
        <span class="ar-step">2</span>
        <h3>Notification email</h3>
        <span class="ar-sec-sub">optional — sent to the addresses you add</span>
      </div>
      <div class="ar-lead">
        <mat-icon>mark_email_read</mat-icon>
        <span>We are pleased to inform you that <b>{{ personName }}</b> has been officially <b>accepted</b>.</span>
      </div>

      <mat-form-field appearance="outline" class="ar-field">
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="Add a message to the email (optional)" rows="2"
                  cdkAutosizeMinRows="2" cdkAutosizeMaxRows="4" [(ngModel)]="message"></textarea>
      </mat-form-field>

      <div class="ar-email-row">
        <mat-form-field appearance="outline" class="ar-field">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>alternate_email</mat-icon>
          <input matInput maxlength="200" placeholder="name@example.com" [(value)]="emailAssigned"
                 (input)="emailCheck($event.target.value)" (keydown.enter)="addEmailButtonShow && addEmail()" />
        </mat-form-field>
        <button mat-flat-button color="primary" class="ar-add" [disabled]="!addEmailButtonShow" (click)="addEmail()">
          <mat-icon>add</mat-icon> Add
        </button>
      </div>

      <ul class="ar-chips" *ngIf="addUpdateParticipantList?.length">
        <li *ngFor="let ass of addUpdateParticipantList">
          <span class="ar-chip-av">
            <img *ngIf="ass.img" [src]="ass.img" alt="">
            <ng-container *ngIf="!ass.img">{{ ass.shortName }}</ng-container>
          </span>
          <span class="ar-chip-txt"><b>{{ ass.name }}</b><small>{{ ass.email }}</small></span>
          <button mat-icon-button class="ar-chip-x" matTooltip="Remove" (click)="removeParticipant(ass)"><mat-icon>close</mat-icon></button>
        </li>
      </ul>
    </section>

    </div>
    </div>

    <!-- Resident record block — placed left or right depending on the facility picker (see above) -->
    <ng-template #residentSec>
    <!-- ── 2. Resident ── -->
    <section class="ar-section">
      <div class="ar-sec-head">
        <span class="ar-step">1</span>
        <h3>Resident record</h3>
        <span class="ar-count" *ngIf="attachedToCoreList?.length">{{ attachedToCoreList.length }} match{{ attachedToCoreList.length === 1 ? '' : 'es' }}</span>
      </div>
      <p class="ar-hint">
        Residents already named <b>{{ referralName }}</b> are listed below. Select one to link this referral to it,
        or use <b>Accept &amp; Create Resident</b>. <ng-container *ngIf="mfDeferred && !data?.selectedRecord?.coreID">Not sure yet? <b>Accept</b> and create the resident later from the Accepted list.</ng-container>
      </p>

      <div class="ar-list">
        <div class="ar-card" *ngFor="let ass of attachedToCoreList" role="radio" tabindex="0"
             [class.selected]="transactionID === ass.coreID" [attr.aria-checked]="transactionID === ass.coreID"
             (click)="selctCore($event, ass)" (keydown.enter)="selctCore($event, ass)" (keydown.space)="selctCore($event, ass)">
          <span class="ar-avatar">
            <img *ngIf="ass.imageUrl" [src]="ass.imageUrl" alt="">
            <ng-container *ngIf="!ass.imageUrl">{{ ass.shortName }}</ng-container>
          </span>
          <span class="ar-card-txt">
            <span class="nm">{{ ass.name }}</span>
            <span class="em">{{ ass.email || 'no email on file' }}</span>
          </span>
          <mat-icon class="ar-radio">{{ transactionID === ass.coreID ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
        </div>
        <div class="ar-empty" *ngIf="showNoRecordFound==true || !attachedToCoreList?.length">
          <mat-icon>person_search</mat-icon> No matching residents — create a new one, or just Accept.
        </div>

      </div>
    </section>

    </ng-template>
  </mat-dialog-content>

  <!-- Footer matches the e-mail Accept dialog (2026-10-08): Cancel on the left, all accept
       actions on the right as blue filled buttons — Accept · Accept & Create Resident · Accept & link resident -->
  <footer class="ar-actions">
    <button mat-button class="ar-cancel" (click)="close()">Cancel</button>
    <span class="ar-spacer"></span>
    <!-- Decoupled admission: accept now, create/link the resident later from the Accepted list -->
    <!-- Always offered (2026-09-25): accept without touching the resident record — a
         resident already linked stays linked; none → create it later from the Accepted list -->
    <button mat-flat-button color="primary" class="ar-primary" type="button" *ngIf="mfDeferred || onBehalfOfOthersOnly()"
            (click)="acceptOnly()" [disabled]="!canSubmitProviders()"
            [matTooltip]="!canSubmitProviders() ? 'Select the facility this Accept applies to first' : (data?.selectedRecord?.coreID ? 'Accept without a resident — the currently linked resident is unlinked; link or create one later from the Accepted list' : 'Accept without linking or creating a resident — the resident can be created later from the Accepted list')">
      <mat-icon>check_circle</mat-icon> Accept
    </button>
    <!-- Create: in this office, or in the chosen facility's office (accepting for another facility) -->
    <button mat-flat-button color="primary" class="ar-primary" type="button" *ngIf="canCreateNewResident()"
            (click)="createNew()" [disabled]="!canSubmitProviders()"
            [matTooltip]="canSubmitProviders() ? (residentTargetOffice() > 0 ? ('Creates the resident in ' + residentOfficeName()) : '') : 'Select the facility this Accept applies to first'">
      <mat-icon *ngIf="!spinner">person_add</mat-icon>
      <mat-spinner *ngIf="spinner" diameter="18"></mat-spinner>
      Accept &amp; Create Resident
    </button>
    <button mat-flat-button color="primary" class="ar-primary ar-link" type="button" *ngIf="!onBehalfOfOthersOnly()"
            (click)="updateRecord()" [disabled]="!transactionID || !canSubmitProviders()"
            [matTooltip]="!canSubmitProviders() ? 'Select the facility this Accept applies to first' : (transactionID ? '' : 'Select a resident above to link it')">
      <mat-icon>link</mat-icon> Accept &amp; link resident
    </button>
  </footer>

</div>


<app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='transactionID'
  [modulenames]='mainModuleNameForDetails' [modulename]="modulenameUpdate" (closeDetail)="getCloseDetails($event)"
  [aiDetails]="systemFeildsList" [ViewOrUpdate]="vieworUpdate" (SendtoSaved3C)=referralAccepted($event)>
</app-details>

<app-addnew *ngIf="showAddCore" (closeAdd)="getClose($event)" [name]="searchName" [isShared]="isShare"
  [mainModuleName]='mainModuleName' [modulename]='Module' [ngClass]="{'open': showAddCore}"
  [aiDetails]="systemFeildsList" [targetOfficeID]="formTargetOffice()"
  (selectedCoreIdForAI)=getselectedTransactionId($event)>
</app-addnew>
